export default __webpack_public_path__ + "static/tenants-property-d-778af958447ef2f209a2cc6e96d134b4.png";